import React from 'react';
import { X, Circle, Clock, Calendar } from 'lucide-react';
import { COLORS } from '../../config/constants';

const StatusSelectionModal = ({ currentStatus, onClose, onSelectStatus }) => {

    const statusOptions = {
        'Disponível': { text: 'Disponível', color: COLORS.SUCCESS_GREEN, Icon: Circle },
        'Agendamento': { text: 'Agendamento', color: COLORS.PRIMARY_BLUE, Icon: Calendar },
        'Indisponível': { text: 'Indisponível', color: COLORS.CHARCOAL, Icon: Clock },
    };

    const handleSelect = (status) => {
        onSelectStatus(status);
        onClose();
    };

    return (
        // ALTERAÇÃO DE DESIGN: items-end -> items-center
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4" onClick={onClose}>
            {/* ALTERAÇÃO DE DESIGN: rounded-t-2xl -> rounded-2xl */}
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-6" onClick={(e) => e.stopPropagation()}>
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold text-gray-800">Alterar Meu Status</h2>
                    <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200">
                        <X className="w-5 h-5 text-gray-600" />
                    </button>
                </div>

                <div className="space-y-3">
                    {Object.keys(statusOptions).map(statusKey => {
                        const option = statusOptions[statusKey];
                        const isSelected = currentStatus === statusKey;
                        return (
                            <button
                                key={statusKey}
                                onClick={() => handleSelect(statusKey)}
                                className={`w-full flex items-center p-4 rounded-xl text-left font-semibold transition-all duration-200 border-2 ${isSelected ? 'border-blue-500 bg-blue-50' : 'border-transparent bg-gray-100 hover:bg-gray-200'}`}
                            >
                                <option.Icon className={`w-5 h-5 mr-4`} style={{ color: option.color }} />
                                <span className={`${isSelected ? 'text-blue-600' : 'text-gray-700'}`}>{option.text}</span>
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default StatusSelectionModal;
